export default __webpack_public_path__ + "static/avatar-322x600-61c662d2f8b2851a1afd1816116367fc.png";